if (!customElements.get('boreal-load-carriage-hero')) {
  customElements.define('boreal-load-carriage-hero', class extends HTMLElement {
    connectedCallback() {
      if (!window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 768px)').matches) return;

      this.activeTarget = '';
      this.querySelectorAll('[data-boreal-lch-target]').forEach((hotspot) => {
        const target = hotspot.dataset.borealLchTarget;
        hotspot.addEventListener('pointerenter', () => this.showTarget(target));
        hotspot.addEventListener('pointerleave', () => this.clearTarget(target));
        hotspot.addEventListener('focus', () => this.showTarget(target));
        hotspot.addEventListener('blur', () => this.clearTarget(target));
      });
    }

    showTarget(target) {
      this.activeTarget = target;
      const image = this.querySelector(`[data-boreal-lch-image="${target}"]`);
      if (!image) return;

      this.loadImage(image).then(() => {
        if (this.activeTarget === target) this.dataset.active = target;
      });
    }

    loadImage(image) {
      if (!image.dataset.src) return Promise.resolve();

      return new Promise((resolve) => {
        const source = image.dataset.src;
        image.addEventListener('load', resolve, { once: true });
        image.addEventListener('error', resolve, { once: true });
        image.src = source;
        image.removeAttribute('data-src');
      });
    }

    clearTarget(target) {
      if (this.activeTarget !== target) return;
      this.activeTarget = '';
      this.removeAttribute('data-active');
    }
  });
}
